module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-section uk-section-muted uk-section-small"
  }, [_c('div', {
    staticClass: "uk-container"
  }, [_c('ul', {
    staticClass: "uk-subnav uk-subnav-pill uk-flex uk-flex-center uk-margin-remove-top",
    attrs: {
      "uk-switcher": "animation: uk-animation-fade"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return (tag.id == 1 || tag.id == 3 || tag.id == 4) ? _c('li', {
      key: tag.id
    }, [_c('a', [_vm._v(_vm._s(tag.name))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "uk-switcher uk-margin"
  }, _vm._l((_vm.tags), function(tag) {
    return (tag.id == 1 || tag.id == 3 || tag.id == 4) ? _c('div', {
      key: _vm.tags.id,
      staticStyle: {
        "padding": "0 40px"
      }
    }, [_c('div', {
      staticClass: "uk-position-relative",
      attrs: {
        "uk-slider": ""
      }
    }, [_c('div', {
      staticClass: "uk-slider-container"
    }, [_c('div', {
      staticClass: "uk-slider-items uk-child-width-1-3@s uk-child-width-1-4@ uk-grid-medium uk-grid-match",
      attrs: {
        "uk-grid": ""
      }
    }, _vm._l((_vm.ShopItems[tag.id]), function(Product) {
      return _c('product', {
        key: Product.ShopItem.id,
        attrs: {
          "shop-item": Product.ShopItem,
          "image": Product.Asset,
          "shop-item-prices": _vm.ShopItemPrices[Product.ShopItem.id],
          "shop-item-properties": _vm.ShopItemProperties[Product.ShopItem.id],
          "shop-item-warehouses": _vm.ShopItemWarehouses[Product.ShopItem.id],
          "shop-item-tags": _vm.ShopItemTags[Product.ShopItem.id],
          "shop-order-item": _vm.page.ShopOrderItems[Product.ShopItem.id]
        },
        on: {
          "buy-shop-item": _vm.buy
        }
      })
    }), 1)]), _vm._v(" "), _c('a', {
      staticClass: "uk-position-center-left-out tm-slider-nav uk-hidden-hover",
      attrs: {
        "href": "#",
        "uk-slidenav-previous": "",
        "uk-slider-item": "previous"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "uk-position-center-right-out tm-slider-nav uk-hidden-hover",
      attrs: {
        "href": "#",
        "uk-slidenav-next": "",
        "uk-slider-item": "next"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-text-center uk-margin-medium-top"
    }, [_c('a', {
      staticClass: "uk-link-muted uk-text-uppercase",
      attrs: {
        "href": tag.href
      }
    }, [_c('span', {
      staticClass: "uk-text-middle"
    }, [_vm._v("Смотреть " + _vm._s(tag.name.toLowerCase()))]), _vm._v(" "), _c('span', {
      staticClass: "uk-text-middle",
      attrs: {
        "uk-icon": "icon: chevron-right"
      }
    })])])]) : _vm._e()
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-649e20da","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/HomeTags.vue
// module id = 153
// module chunks = 0